var $ = require( 'jquery' );

import inview from 'jquery-inview/jquery.inview';
import 'slick-carousel';


$(document).ready(function() {
	postsSlider();
});


$(window).resize(function() {
    var stHeight = $('.slick-track').height();
    $('.slick-slide').css('height',stHeight + 'px' );
})

var slideshowContainer = $( ".news-and-media__posts" );
function postsSlider() {

    var postsCounter = slideshowContainer.attr('data-total-posts');

    if ( postsCounter >= 2 || $(window).width() < 992) {
        slideshowContainer.bind( 'inview', function( event, visible ) {
            if ( visible == true ) {
                slideshowContainer.not('.slick-initialized').slick({
                    dots: true,
                    arrows: false,
                    lazyLoad: 'ondemand',
                    infinite: true,
                    autoplay: true,
                    rows: 0,
                    autoplaySpeed: 4000,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    pauseOnHover: true,
                    adaptiveHeight: true,
                    pauseOnFocus: false,
                    responsive: [
                        {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                            }
                        }
                    ]
                });
    
                var stHeight = $('.slick-track').height();
                $('.slick-slide').css('height',stHeight + 'px' );
            }
        });
    }
   
}